class AppError extends Error {
    severity;
    title;
    message;
    rootCause;
    constructor({ severity, title, message }, rootCause){
        super(title ?? 'Something happened on our end');
        this.severity = severity ?? 'error';
        this.title = title ?? 'Something happened on our end';
        this.message = message ?? 'Try again and contact Chronosphere support if the issue persists';
        this.rootCause = rootCause;
        Object.setPrototypeOf(this, AppError.prototype);
    }
}
export { AppError };

//# sourceMappingURL=AppError.js.map